import { Segment } from '../Segment/Segment';
import styles from './WrapperSegment.module.css';

export const WrapperSegment = ({
  width = '3306',
  left = '0,',
  noiseLevel,
  coeef,
}) => {
  return (
    <div
      style={{ width: Number(width), height: Math.round(168 / coeef) }}
      className={styles.wrapperSegment}
    >
      <Segment left={-Number(left)} noiseLevel={noiseLevel} coeef={coeef} />
    </div>
  );
};
